<template>
  <div class="outer">
    <div class="row g-0 align-items-center mb-4">
      <div class="col-12 col-md">
        <h2 class="display-3 fw-normal mb-3 mb-md-0">自動車貸渡契約書</h2>
      </div>
      <!-- /.col -->
      <div class="col-12 col-md-7 col-lg-6 col-xl-5">
        <table class="table table-bordered">
          <tbody class="border-1 lh-md">
            <tr>
              <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
                伝票
              </td>
              <td class="align-middle px-lg-3">
                <div class="input-group input-group-sm w-9em">
                  <span class="input-group-text">No.</span>
                  <input
                    type="text"
                    id="slipNo"
                    name="slipNo"
                    class="form-control form-control-sm"
                    v-model.number="rentalContractEditForm.slipNo"
                  />
                  <div class="invalid-feedback">
                    {{ errors.slipNo.message }}
                  </div>
                </div>
                <!-- /.input-group -->
              </td>
              <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
                担当者
              </td>
              <td class="align-middle px-lg-3">
                <select
                  id="managerId"
                  name="managerId"
                  v-model="rentalContractEditForm.managerId"
                  class="form-select form-select-sm"
                >
                  <optgroup
                    v-for="(department, id) in usersForSinglePulldownByVue
                      .users[0]"
                    :label="department.departmentName"
                    :key="id"
                  >
                    <option
                      v-for="user in department.users"
                      :value="user.id"
                      :key="user.id"
                    >
                      {{ user.name }}
                    </option>
                  </optgroup>
                </select>
                <div class="invalid-feedback">
                  {{ errors.managerId.message }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
                配車日
              </td>
              <td class="align-middle px-lg-3" colspan="3">
                <input
                  type="date"
                  id="dispatchDate"
                  name="dispatchDate"
                  class="form-control form-control-sm"
                  placeholder="カレンダーから選択"
                  v-model="rentalContractEditForm.dispatchDate"
                />
                <div class="invalid-feedback">
                  {{ errors.dispatchDate.message }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->

    <table class="table table-bordered">
      <tbody class="border-1 lh-md">
        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label for="rentCarId" class="form-label">車輌</label>
          </td>
          <td class="align-middle px-lg-3">
            <select
              class="form-select form-select-sm"
              id="rentCarId"
              name="rentCarId"
              v-model="rentalContractEditForm.rentCarId"
            >
              <option
                v-for="option in carModelsForPulldownByVue.carModels"
                v-bind:key="option.value"
                v-bind:value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <div class="invalid-feedback">
              {{ errors.rentCarId.message }}
            </div>
          </td>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="rentCarNo" class="form-label"> 登録ナンバー </label>
          </td>
          <td class="align-middle px-lg-3">
            <input
              type="text"
              id="rentCarNo"
              name="rentCarNo"
              class="form-control form-control-sm"
              v-model.number="rentalContractEditForm.rentCarNo"
            />
            <div class="invalid-feedback">
              {{ errors.rentCarNo.message }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-3"
            rowspan="3"
          >
            <div class="vertical">借受人契約者</div>
          </td>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="contractorCompanyName" class="form-label">
              会社名・<br class="d-lg-none" />団体名
            </label>
          </td>
          <td class="align-middle px-lg-3" colspan="3">
            <div class="row gx-2 gy-1 align-items-center">
              <div class="col">
                <input
                  type="text"
                  id="contractorCompanyName"
                  name="contractorCompanyName"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.contractorCompanyName"
                />
                <div class="invalid-feedback">
                  {{ errors.contractorCompanyName.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-auto">様</div>
            </div>
            <!-- /.row -->
          </td>
        </tr>
        <tr>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="contractorAddress" class="form-label"> 住所 </label>
          </td>
          <td class="align-middle px-lg-3" colspan="3">
            <input
              type="text"
              id="contractorAddress"
              name="contractorAddress"
              class="form-control form-control-sm"
              v-model="rentalContractEditForm.contractorAddress"
            />
            <div class="invalid-feedback">
              {{ errors.contractorAddress.message }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="contractorManager" class="form-label"> 担当者 </label>
          </td>
          <td class="align-middle px-lg-3" colspan="2">
            <div class="row gx-2 gy-1 align-items-center">
              <div class="col">
                <input
                  type="text"
                  id="contractorManager"
                  name="contractorManager"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.contractorManager"
                />
                <div class="invalid-feedback">
                  {{ errors.contractorManager.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-auto">様</div>
            </div>
            <!-- /.row -->
          </td>
          <td class="align-middle px-lg-3">
            <div class="input-group input-group-sm">
              <span class="input-group-text">TEL</span>
              <input
                type="text"
                id="contractorTel"
                name="contractorTel"
                class="form-control form-control-sm"
                v-model="rentalContractEditForm.contractorTel"
              />
              <div class="invalid-feedback">
                {{ errors.contractorTel.message }}
              </div>
            </div>
            <!-- /.input-group -->
          </td>
        </tr>
        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-3"
            rowspan="4"
          >
            <div class="vertical">運転手</div>
          </td>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="driverName" class="form-label"> 氏名 </label>
          </td>
          <td class="align-middle px-lg-3">
            <div class="row gx-2 gy-1 align-items-center">
              <div class="col">
                <input
                  type="text"
                  id="driverName"
                  name="driverName"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.driverName"
                />
                <div class="invalid-feedback">
                  {{ errors.driverName.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-auto">様</div>
            </div>
            <!-- /.row -->
          </td>
          <td class="align-middle text-center px-lg-3">
            <div class="form-check form-check-inline me-2">
              <input
                type="radio"
                id="driver_sex_men"
                name="driver_sex"
                value="1"
                class="form-check-input"
                v-model="rentalContractEditForm.driverSex"
                checked
              />
              <label class="form-check-label" for="driver_sex_men"> 男 </label>
            </div>
            <!-- /.form-check -->
            <div class="form-check form-check-inline me-2">
              <input
                type="radio"
                id="driver_sex_woman"
                name="driver_sex"
                value="2"
                class="form-check-input"
                v-model="rentalContractEditForm.driverSex"
              />
              <label class="form-check-label" for="driver_sex_woman">
                女
              </label>
            </div>
            <!-- /.form-check -->
          </td>
          <td class="align-middle px-lg-3">
            <input
              type="date"
              id="driverBirthday"
              name="driverBirthday"
              class="form-control form-control-sm"
              v-model="rentalContractEditForm.driverBirthday"
              placeholder="カレンダーから選択"
            />
            <div class="invalid-feedback">
              {{ errors.driverBirthday.message }}
            </div>
          </td>
        </tr>

        <tr>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="driverAddress" class="form-label"> 住所 </label>
          </td>
          <td class="align-middle px-lg-3" colspan="2">
            <input
              type="text"
              id="driverAddress"
              name="driverAddress"
              class="form-control form-control-sm"
              v-model="rentalContractEditForm.driverAddress"
            />
            <div class="invalid-feedback">
              {{ errors.driverAddress.message }}
            </div>
          </td>

          <td class="align-middle px-lg-3">
            <div class="input-group input-group-sm">
              <span class="input-group-text">TEL</span>
              <input
                type="text"
                id="driverTel"
                name="driverTel"
                class="form-control form-control-sm"
                v-model="rentalContractEditForm.driverTel"
              />
              <div class="invalid-feedback">
                {{ errors.driverTel.message }}
              </div>
            </div>
            <!-- /.input-group -->
          </td>
        </tr>
        <tr>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label class="form-label">
              運転免許
              <br class="d-lg-none" />
              番号
            </label>
          </td>
          <td class="align-middle px-lg-3" colspan="2">
            <input
              type="text"
              id="driverLicenseNo"
              name="driverLicenseNo"
              class="form-control form-control-sm"
              v-model.number="rentalContractEditForm.driverLicenseNo"
            />
            <div class="invalid-feedback">
              {{ errors.driverLicenseNo.message }}
            </div>
          </td>
          <td class="align-middle px-lg-3">
            <select
              id="drivingLicenseTypeId"
              name="drivingLicenseTypeId"
              class="form-select form-select-sm"
              v-model="rentalContractEditForm.drivingLicenseTypeId"
            >
                <option
                    v-for="option in driverLicenseTypesForPulldownByVue.driverLicenseTypes"
                    v-bind:key="option.value"
                    v-bind:value="option.value"
                >
                    {{ option.text }}
                </option>
            </select>
            <div class="invalid-feedback">
              {{ errors.drivingLicenseTypeId.message }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label class="form-label">有効期限</label>
          </td>
          <td class="align-middle px-lg-3" colspan="4">
            <div class="row gx-2 gy-1 align-items-center row-cols-auto">
              <div class="col">
                <input
                  type="number"
                  id="driverLicenseExpireYear"
                  name="driverLicenseExpireYear"
                  class="form-control form-control-sm"
                  v-model.number="
                    rentalContractEditForm.driverLicenseExpireYear
                  "
                />
                <div class="invalid-feedback">
                  {{ errors.driverLicenseExpireYear.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col">年の誕生日まで有効</div>
            </div>
            <!-- /.row -->
          </td>
        </tr>
        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label class="form-label">貸渡日</label>
          </td>
          <td class="align-middle px-lg-3" colspan="3">
            <div class="row gx-2 gy-1 align-items-center row-cols-auto">
              <div class="col-4">
                <input
                  type="date"
                  id="lentDate"
                  name="lentDate"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.lentDate"
                />
                <div class="invalid-feedback">
                  {{ errors.lentDate.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-4">
                <input
                  type="time"
                  id="lentTime"
                  name="lentTime"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.lentTime"
                />
                <div class="invalid-feedback">
                  {{ errors.lentTime.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-4">
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    id="lentDateDrivingDistance"
                    name="lentDateDrivingDistance"
                    class="form-control form-control-sm w-8em"
                    v-model.number="
                      rentalContractEditForm.lentDateDrivingDistance
                    "
                    placeholder="走行距離"
                  />
                  <span class="input-group-text">km</span>
                  <div class="invalid-feedback">
                    {{ errors.lentDateDrivingDistance.message }}
                  </div>
                </div>
                <!-- /.input-group -->
              </div>
              <!-- /.col -->
            </div>
            <!-- /.row -->
          </td>
        </tr>
        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label class="form-label">返却日</label>
          </td>
          <td class="align-middle px-lg-3" colspan="3">
            <div class="row gx-2 gy-1 align-items-center row-cols-auto">
              <div class="col-4">
                <input
                  type="date"
                  id="returnDate"
                  name="returnDate"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.returnDate"
                />
                <div class="invalid-feedback">
                  {{ errors.returnDate.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-4">
                <input
                  type="time"
                  id="returnTime"
                  name="returnTime"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.returnTime"
                />
                <div class="invalid-feedback">
                  {{ errors.returnTime.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-4">
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    id="returnDateDrivingDistance"
                    name="returnDateDrivingDistance"
                    class="form-control form-control-sm w-8em"
                    v-model.number="
                      rentalContractEditForm.returnDateDrivingDistance
                    "
                    placeholder="走行距離"
                  />
                  <span class="input-group-text">km</span>
                  <div class="invalid-feedback">
                    {{ errors.returnDateDrivingDistance.message }}
                  </div>
                </div>
                <!-- /.input-group -->
              </div>
              <!-- /.col -->
            </div>
            <!-- /.row -->
          </td>
        </tr>

        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label class="form-label">車検満了日</label>
          </td>
          <td class="align-middle px-lg-3" colspan="3">
            <div class="row gx-2 gy-1 align-items-center row-cols-auto">
              <div class="col-5">
                <input
                  type="date"
                  id="vehicleInspectionExpiryDate"
                  name="vehicleInspectionExpiryDate"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.vehicleInspectionExpiryDate"
                />
                <div class="invalid-feedback">
                  {{ errors.vehicleInspectionExpiryDate.message }}
                </div>
              </div>
              <!-- /.col -->
            </div>
            <!-- /.row -->
          </td>
        </tr>

        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label for="maintenanceDate" class="form-label">
              点検整備実施
            </label>
          </td>
          <td class="align-middle px-lg-3">
            <input
              type="date"
              id="maintenanceDate"
              name="maintenanceDate"
              class="form-control form-control-sm"
              v-model="rentalContractEditForm.maintenanceDate"
              placeholder="カレンダーから選択"
            />
            <div class="invalid-feedback">
              {{ errors.maintenanceDate.message }}
            </div>
          </td>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="maintenancePersonId" class="form-label">
              整備担当
            </label>
          </td>
          <td class="align-middle px-lg-3">
            <select
              id="maintenancePersonId"
              name="maintenancePersonId"
              v-model="rentalContractEditForm.maintenancePersonId"
              class="form-select form-select-sm"
            >
                <option
                    :value="null"
                    :key="null"
                >
                </option>
              <optgroup
                v-for="(department, id) in usersForSinglePulldownByVue.users[0]"
                :label="department.departmentName"
                :key="id"
              >
                <option
                  v-for="user in department.users"
                  :value="user.id"
                  :key="user.id"
                >
                  {{ user.name }}
                </option>
              </optgroup>
            </select>
            <div class="invalid-feedback">
              {{ errors.maintenancePersonId.message }}
            </div>
          </td>
        </tr>

        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label class="form-label">使用目的</label>
          </td>
          <td class="align-middle px-lg-3" colspan="3">
            <div class="row gx-3 align-items-center row-cols-auto">
              <div class="col-6">
                <select
                  id="usageObjectiveId"
                  name="usageObjectiveId"
                  class="form-select form-select-sm"
                  v-model="rentalContractEditForm.usageObjectiveId"
                >
                  <option
                    v-for="option in usageObjectivesForPulldownByVue.usageObjectives"
                    v-bind:key="option.value"
                    v-bind:value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  {{ errors.usageObjectiveId.message }}
                </div>
              </div>
              <!-- /.col -->
            </div>
            <!-- /.row -->
          </td>
        </tr>
        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label for="dischargeAmount" class="form-label">免責金額(万円)</label>
          </td>
          <td class="align-middle px-lg-3">
            <input
              type="text"
              id="dischargeAmount"
              name="dischargeAmount"
              class="form-control form-control-sm"
              v-model.number="rentalContractEditForm.dischargeAmount"
            />
            <div class="invalid-feedback">
              {{ errors.dischargeAmount.message }}
            </div>
          </td>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="nocSubscriptionAmount" class="form-label">NOC加入金額(万円)</label>
          </td>
          <td class="align-middle px-lg-3">
            <input
              type="text"
              id="nocSubscriptionAmount"
              name="nocSubscriptionAmount"
              class="form-control form-control-sm"
              v-model.number="rentalContractEditForm.nocSubscriptionAmount"
            />
            <div class="invalid-feedback">
              {{ errors.nocSubscriptionAmount.message }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-3"
            rowspan="2"
          >
            <div class="vertical">配送先</div>
          </td>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="destAddress" class="form-label"> 住所 </label>
          </td>
          <td class="align-middle px-lg-3" colspan="3">
            <input
              type="text"
              id="destAddress"
              name="destAddress"
              class="form-control form-control-sm"
              v-model="rentalContractEditForm.destAddress"
            />
            <div class="invalid-feedback">
              {{ errors.destAddress.message }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="align-middle text-center bg-g05 text-nowrap px-lg-3">
            <label for="destManager" class="form-label"> 氏名 </label>
          </td>
          <td class="align-middle px-lg-3" colspan="2">
            <div class="row gx-2 gy-1 align-items-center">
              <div class="col">
                <input
                  type="text"
                  id="destManager"
                  name="destManager"
                  class="form-control form-control-sm"
                  v-model="rentalContractEditForm.destManager"
                />
                <div class="invalid-feedback">
                  {{ errors.destManager.message }}
                </div>
              </div>
              <!-- /.col -->
              <div class="col-auto">様</div>
            </div>
            <!-- /.row -->
          </td>
          <td class="align-middle px-lg-3">
            <div class="input-group input-group-sm">
              <span class="input-group-text">TEL</span>
              <input
                type="text"
                id="destTel"
                name="destTel"
                class="form-control form-control-sm"
                v-model="rentalContractEditForm.destTel"
              />
              <div class="invalid-feedback">
                {{ errors.destTel.message }}
              </div>
            </div>
            <!-- /.input-group -->
          </td>
        </tr>
        <!-- /.col -->

        <tr>
          <td
            class="align-middle text-center bg-g05 text-nowrap px-lg-3"
            colspan="2"
          >
            <label class="form-label">燃料</label>
          </td>
          <td class="align-middle px-3 px-lg-4" colspan="3">
            <div class="range">
              <input
                type="range"
                id="fuel"
                name="fuel"
                class="form-range"
                min="0"
                max="4"
                v-model.number="rentalContractEditForm.fuel"
              />
              <span class="empty">E</span>
              <span class="full">F</span>
              <span class="range_20"></span>
              <span class="range_40"></span>
              <span class="range_60"></span>
              <span class="range_80"></span>
            </div>
            <!-- /.range -->
          </td>
        </tr>
      </tbody>
    </table>
    <div class="border border-top-0 p-3">
      <h4 class="d-inline-block h5 fw-normal mb-1 me-2">お客様への注意事項</h4>
      <p class="d-inline-block fs-small">
        ◎貸渡約款に違反した場合は、全責任がお客様にかかりますので御注意下さい。
      </p>
      <p class="kome">
        ①本書は運行中に必ず携帯し、警察官又は運輸局もしくは陸運支局の職員から請求があった時は呈示しなければならない。
      </p>
      <p class="kome">
        ②自動車の借受に付随して、貸渡人から運転者の労務供給（運転者の紹介および斡旋を含む。）を受ける事ができない。
      </p>
      <p class="kome">
        ③受期間中に的確な運行前点検を行うとともに異常を発見した場合には、当該異常カ所の整備を完了した後運行しなければならない。
      </p>
      <p class="kome">
        ④貸渡自動車に係る事故が発生した場合は、必ず警察に届けるとともに貸渡人にご連絡ください。また貸渡自動車が故障した場合も同様にご連絡ください。
      </p>
      <p class="kome">
        ⑤貸渡期間が2日以上となる場合には、お客様において的確な運転前点検を行うとともに異常を発見した場合には、貸渡人にご連絡頂くとともに、該当異常カ所の整備を完了した後運行しなければならない。
      </p>
      <p class="kome">⑥レンタカーは燃料を満タンにしてお返し下さい。</p>
      <p class="kome">
        ⑦貸渡期間中の放置駐車違反により、レンタカー会社が放置違反金納付命令を受けた場合に放置違反金額と付帯費用の実額お支払いいただきます。
      </p>
      <p class="kome mb-2">
        ⑧その他、お気づきの点等ございましたら貸渡人へご連絡下さい。
      </p>
      <p class="kome">
        ◎万一事故が起こった場合は、最寄りの警察署で必要は法的手続きを行い、直ちに当社にご連絡下さい。
      </p>
      <p class="kome">
        〇貸渡約款29条2公に定める場合、当社がレンタカーについて締結した損害保険契約により、次の限度内の保険金が給付されます。
      </p>
      <ul class="list-inline ms-3">
        <li class="me-3 align-top">対人保証：無制限</li>
        <li class="me-3 align-top">対物保証：無制限（免責額5万円）</li>
        <li class="me-3 align-top">
          車輌補償：時価額（免責額
          <span class="p-0 m-0 ms-1">
            {{ rentalContractEditForm.dischargeAmount ? rentalContractEditForm.dischargeAmount.toLocaleString() : rentalContractEditForm.dischargeAmount }}
          </span>
          万円）
        </li>
        <li class="me-3 align-top">
          営業補償：（
          <span class="p-0 m-0 mx-1">
            {{ rentalContractEditForm.nocSubscriptionAmount ? rentalContractEditForm.nocSubscriptionAmount.toLocaleString() : rentalContractEditForm.nocSubscriptionAmount }}
          </span>
          万円）
          <br />
          <small>自走不可能の場合は別途費用発生します</small>
        </li>
        <li>人身傷害補償：3,000万円</li>
      </ul>
      <hr class="my-2" />
      <h4 class="h5 fw-normal">株式会社エースレンタカー</h4>
      <p>
        〒003-0871 北海道札幌市白石区米里1条2丁目14-14<br />TEL：0120-111-503　FAX：011-595-8132
      </p>
    </div>
    <!-- /.border -->
  </div>
  <!-- /.outer -->
  <!-- ―――― Modal ―――― -->
  <RentalContractConfirmModal></RentalContractConfirmModal>
  <!-- ―――― ./Modal ―――― -->
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent } from "vue";
/* Import Components */
import RentalContractConfirmModal from "../rentalContractConfirmModal.vue";
/* Import Variables */
import {
  carModelsForPulldownByVue,
  driverLicenseTypesForPulldownByVue,
  rentalContractEditForm,
  usageObjectivesForPulldownByVue,
  usersForSinglePulldownByVue,
} from "../../../compositions/variables";
import { errors } from "../../../compositions/validation/validation";

/* Import Functions */
export default defineComponent({
  components: {
    RentalContractConfirmModal,
  },
  setup() {
    return {
      /* variables */
      carModelsForPulldownByVue,
      driverLicenseTypesForPulldownByVue,
      errors,
      rentalContractEditForm,
      usageObjectivesForPulldownByVue,
      usersForSinglePulldownByVue,
      /* functions */
    };
  },
});
</script>
